import { render, staticRenderFns } from "./TinyCard.vue?vue&type=template&id=3f7df5de&scoped=true"
import script from "./TinyCard.vue?vue&type=script&lang=js"
export * from "./TinyCard.vue?vue&type=script&lang=js"
import style0 from "./TinyCard.vue?vue&type=style&index=0&id=3f7df5de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../imicsspa/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7df5de",
  null
  
)

export default component.exports